import React from 'react';
const stats = [{
  value: '6',
  label: 'Tomos paso a paso'
}, {
  value: '6',
  label: 'Bonos de regalo'
}, {
  value: '12',
  label: 'Meses de plan'
}, {
  value: '7',
  label: 'Días de garantía'
}];
export function StatsStrip() {
  return <section aria-label="El sistema en números" className="w-full bg-cream-100" data-id="element-178" data-mp="2jqk6xg31bxb">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 divide-cream-300 px-5 lg:grid-cols-4 lg:divide-x lg:px-8" data-id="element-179" data-mp="7hs23f1rv577">
        {stats.map(stat => <div key={stat.label} className="px-4 py-8 text-center lg:py-10" data-id="element-180" data-mp="105o7r99bk7g4">
            <dt className="sr-only" data-id="element-181" data-mp="107qw7outpsiq">{stat.label}</dt>
            <dd data-id="element-182" data-mp="lhjlxweyzft4">
              <span className="block font-display text-4xl font-extrabold text-forest-700" data-id="element-183" data-mp="lfyuifnycczh">
                {stat.value}
              </span>
              <span className="mt-1 block text-sm text-forest-600/80" data-id="element-184" data-mp="qdi77b504hpb">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}